import { render, staticRenderFns } from "./BranchView.vue?vue&type=template&id=1355bca2&"
import script from "./BranchView.vue?vue&type=script&lang=ts&"
export * from "./BranchView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports